<template>
  <div class="product-expand">
    <div class="product-expand-header">
      <div class="title">
        <div class="icon-wrapper">
          <slot name="icon">
            <img src="/assets/images/icon-open-case.svg" alt="">
          </slot>
        </div>
        <slot name="title">
          <h3>{{ $props.groupTitle }}</h3>
        </slot>
      </div>
      <base-button class="show-more-button"
                   :variant="contentVisible ? 'text' : 'primary'"
                   @click="toggleContentVisibility">
        <template v-if="contentVisible">
          <img src="/assets/images/icon-close-red.svg" width="8" alt="x"> {{ $t('common.showLess') }}
        </template>
        <template v-else>
          {{ $t('common.showMore') }}
        </template>
      </base-button>
    </div>
    <height-transition>
      <div v-if="contentVisible">
        <slot/>
      </div>
    </height-transition>
  </div>
</template>

<script>
import BaseButton from '@/components/base/base-button'
import HeightTransition from './height-transition'

export default {
  name: 'products-expand',
  components: { HeightTransition, BaseButton },
  data () {
    return {
      contentVisible: !!this.$props.visibleOnLoad
    }
  },
  props: {
    groupTitle: String,
    visibleOnLoad: Boolean
  },
  methods: {
    toggleContentVisibility () {
      this.contentVisible = !this.contentVisible
    }
  }
}
</script>

<style scoped lang="scss">
.product-expand {

  &-header {
    background-color: $white;
    border-radius: 0.6rem;
    padding: 2.4rem;
    display: flex;
    flex-direction: column;

    @media (map_get($breakpoints, sm)) {
      padding: 3rem 2.4rem;
      flex-direction: row;
    }
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2.4rem;
    flex: 1 1 auto;

    @media (map_get($breakpoints, sm)) {
      justify-content: flex-start;
      margin-bottom: 0;
    }

    .icon-wrapper {
      width: 3.2rem;
      height: 3.2rem;
      text-align: center;
      margin-right: 2.4rem;

      /deep/ img {
        width: auto;
        object-fit: contain;
        height: 3.2rem;
      }
    }

    h3 {
      font-size: 1.6rem;
      font-weight: normal;
      color: $text;
      margin: 0;

      @media (map_get($breakpoints, sm)) {
        font-size: 2.4rem;
      }
    }
  }

  .show-more-button {
    width: 100%;
    display: block;
    padding: 1.4rem !important;
    min-height: 4.8rem;
    margin-left: auto;
    flex-grow: 0;

    @media (map_get($breakpoints, sm)) {
      width: auto;
    }

    img {
      margin-right: 8px;
    }
  }
}
</style>
